export default __webpack_public_path__ + "static/media/pen.438c7ade.svg";